<template>
    <div>
        <h1 style="font-size: 24px; color: black;">分类搜索统计</h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-form  :inline="true" :model="queryData" size="small" >
                <el-form-item label="关键字：">
                   <el-input v-model="queryData.name" style="width: 200px" clearable></el-input>
                </el-form-item> 
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                            >
                    </el-date-picker>
                    <!-- &emsp;&emsp; -->
                </el-form-item>
                    <!-- <el-form-item label="渠道：">   value-format="yyyy-MM-dd"
                            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                                    placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                            </el-select>
                            <el-select v-model="queryData.subChannelId" clearable @clear="clearValue" placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option value="-1" label="渠道汇总"></el-option>
                                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                                        :value="item.subChannel"></el-option>
                            </el-select>
                    </el-form-item> -->
                <el-form-item label="">
                    <el-button class="sub-sub9" type="primary" @click="query">查询</el-button>
                    <el-button class="sub-sub9" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>

<!-- 用户分析以及 图表展示 -->
        <el-card class="form-container-user" style="margin-top: 25px" shadow="never">
            <h2>搜索用户统计</h2>
            <el-row>
                <el-col :span="8">
                    <div >
                        <el-table
                                border
                                :data="dayList"
                                ref="dayListCard"
                                max-height="820">
                            <el-table-column   label="日期" prop="day" align="center"></el-table-column>
                            <el-table-column   label="总人数"    prop="total" align="center"></el-table-column>
                            <!-- 这里自动转成小写字段了  可能是后台哪里过滤器筛选处理了 -->
                            <el-table-column   label="新用户数"  prop="newusercount" align="center"></el-table-column>
                            <el-table-column   label="老用户数"  prop="oldusercount" align="center"></el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="16" >
                    <div id="chart" ref="chart" style="width:100%;min-height:400px;"   ></div>
                </el-col>
            </el-row>  
        </el-card>

        <h1>
            <el-table
                    border
                    :data="dataList"
                    ref="filterTable"
                    @sort-change='sortChange'
                    max-height="820">
                <el-table-column   label="关键词" prop="name" align="center"></el-table-column>
                <el-table-column   label="总人数" sortable="custom"  prop="total" align="center"></el-table-column>
                <!-- 这里自动转成小写字段了  可能是后台哪里过滤器筛选处理了 -->
                <el-table-column   label="总搜索次数" sortable="custom"  prop="totaltimecount" align="center"></el-table-column>
                <el-table-column   label="有结果次数" sortable="custom"  prop="truecount" align="center"></el-table-column>
                <el-table-column   label="没结果次数" sortable="custom"  prop="falsecount" align="center"></el-table-column>
                <!-- <el-table-column   label="是否有结果"   prop="resultFlag" :formatter="resultFlagFormatter" align="center"></el-table-column> -->
                <!-- <el-table-column   label="用户类型" prop="userType" align="center" :formatter="userTypeFormatter"></el-table-column> -->
                <!-- <el-table-column   label="渠道号" prop="channelId" align="center" :formatter="channelFormatter"></el-table-column> -->
                <!-- <el-table-column   label="总领取人数" prop="totalUserCount" align="center"></el-table-column>
                <el-table-column   label="总领取数量" prop="totalNumberCount" align="center"></el-table-column> -->
            </el-table>
        </h1>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        // channelList,
        searchClassifyRecord,
        analysisClassifyRecordByDay
    } from "@/http/api";
    // import utils from '@/utils'
    export default {
        name: "ClassifyReport",
        data(){
            return{
                // channelList: [],
                // subChannelList: [],                    
                queryData:{
                    name: null,
                    timeDate: [new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)],
                    startTime:null,
                    endTime:null,
                    orders: " total desc"
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                // versionList:[],
                // chatRoomList:[],
                dataList:[],
                dayList:[],
                dayFormatList:[],
                myChart:null,
            }
        },
        methods:{
            // channelFormatter: function (row, column, cellValue){
            //     var temp="其他"
            //     this.channelList.forEach( item => {
            //         if(item.id==cellValue){
            //             temp=item.name;
            //             } 
            //     })
            //     return temp
            //     },
            resultFlagFormatter: function (row, column, cellValue){
                return cellValue?"是":"否"
                },
            // selectGoodsByChannelId(val) {
            //     // this.watchTag = val;
            //     if (val !== null && val !== '' && val !== undefined && val !== '0') {
            //         this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
            //     }
            //     if (val === '0') {
            //         this.subChannelList = [];
            //     }
            //     this.queryData.subChannelId=null;
            // },
            clearValue(){
                this.queryData.subChannelId=null;
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '搜索分类统计.xlsx';
                downloadData(
                    '/classify/exportReportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = [new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)];
                }
                this.queryData.startTime = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endTime = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchClassifyRecord(this.queryData).then(resp=>{
                    // console.log(resp)
                    this.dataList=resp.data.info.list;
                    this.page.totalElements =resp.data.info.totalElements;
                    // 查询日期升序排列
                        var tempQuery={
                            startTime:this.queryData.startTime,
                            endTime:this.queryData.endTime
                        }
                        analysisClassifyRecordByDay(tempQuery).then(resp=>{

                            // console.log(resp)
                            this.dayList=resp.data.info.list;
                            // this.dayList=[{
                            //     "total": 27631,
                            //     "newusercount": 5547,
                            //     "oldusercount": 22084,
                            //     "day": "2022-08-09"
                            //     }, 
                            //     ];
                            //处理echart数据格式化
                            // 1.ES5 引入了Object.keys方法，成员是参数对象自身的（不含继承的）所有可遍历（ enumerable ）属性的键名。

                            let keyArray = Object.keys(this.dayList[0])  // [ 'id' , 'createData' , 'num'] 
                            // 2. 声明一个新的数组 , 等待获取我们处理格式化后的新的值 , 通过循环再赋值的形式获取新的格式化的数组
                            let data = []
                            keyArray.forEach(item=>{ // item就是keyArray数组中每一个key
                            data.push({
                                    name:item,
                                    data:this.dayList.map(g=>g[item]), // 这里通过数组的map() 方法按照原始数组元素顺序依次处理元素。
                                }) 
                            })
                            // 延时刷新表格因为如果没这个 刷新出来的echart 高度会特别窄 查到的方案是加一个延时即可
                            setTimeout(() =>{
                                this.dayFormatList=data; 
                                },500);
                            // this.drawChart();
                        });
                });
                
            },
            //修改排序顺序
            sortChange(param){
                // console.log(param);
                if(param.prop == null ){
                    return;
                }else {
                    if( param.order == null){
                        return;
                    }else {
                        // console.log(param.order);
                        // if(param.prop==="name"){
                        //     this.queryData.orders="CONVERT(name USING gbk) COLLATE gbk_chinese_ci % "+param.order;
                        // }else{
                            this.queryData.orders= new RegExp("^desc").test(param.order)?param.prop+" "+"desc":param.prop+" "+"asc" ;
                        // }
                        
                        // console.log(this.queryData.orders)
                    }
                }
                this.query();
            },
            drawChart() {
                // console.log("drawchart");
                // console.log(this.dayFormatList)
                // console.log(this.myChart)
                // console.log(this.$refs.dayListCard)
                if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
                    // console.log(this.myChart)
                        this.myChart.dispose();//销毁
                    }
                // this.$nextTick;
                
                var chartDom = document.getElementById("chart");
                var myChart = this.$echarts.init(chartDom);
                this.myChart = myChart;
                var option = { 
                        xAxis: {
                            name: "日期",  
                            data: this.dayFormatList.find(a=>{return a.name=="day"}).data
                        },
                        yAxis: {
                            name: "人数",  
                        },
                        legend: {
                            orient:"horizontal",//水平展示，不写默认水平展示
                            right: 10,
                            top: 20,
                            data: ["总用户数","新用户数","老用户数"]
                        },
                        series: [
                            {
                                name: "总用户数",  
                                type: 'bar',
                                data: this.dayFormatList.find(a=>{return a.name=="total"}).data,
                                barGap: '20%',
                                barCategoryGap: '40%'
                            },
                            {
                                name: "新用户数",  
                                type: 'bar',
                                data: this.dayFormatList.find(a=>{return a.name=="newusercount"}).data
                            },
                            {
                                name: "老用户数",  
                                type: 'bar',
                                data: this.dayFormatList.find(a=>{return a.name=="oldusercount"}).data
                            }
                        ],
                        tooltip : {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross',
                                label: {
                                    backgroundColor: '#6a7985'
                                }
                            }
                        }
                    } 
                // console.log(option)
                var mWidth = this.$refs.dayListCard.$el.offsetWidth*2;  // 获取父节点宽高
                var mHeight = this.$refs.dayListCard.$el.offsetHeight; 
                // console.log(mWidth)
                // console.log(mHeight)
                myChart.resize({width:mWidth, height:Math.max(400,mHeight)})
                option && myChart.setOption(option) ;
            } 
        },
        watch: {
            dayFormatList() {
                this.drawChart();
            },
            },
        created() {
            // console.log(new Date().toLocaleDateString())
            this.queryData.timeDate=[new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)];
            // channelList().then(resp => {
            // this.channelList = resp.data.info;
            // });
            this.query();
        },
    }
</script>

<style scoped>
    .sub-sub9{ position: relative; left: 110px}
</style>
